import { render } from "./CreateFromSet.vue?vue&type=template&id=2b5dd1b1&scoped=true"
import script from "./CreateFromSet.vue?vue&type=script&lang=js"
export * from "./CreateFromSet.vue?vue&type=script&lang=js"

import "./CreateFromSet.vue?vue&type=style&index=0&id=2b5dd1b1&scoped=true&lang=css"

import exportComponent from "/Users/janvalenta/Documents/Projects/sites/somisale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b5dd1b1"]])

export default __exports__